import { createStyles, Theme } from '@material-ui/core/styles';
import getRelativePath from '../utils/path';

/**
 *
 * @param {Theme} theme Material Theme.
 * @returns {Theme} Return Material Themes.
 */
const Styles = (theme: Theme) =>
	createStyles({
		root: {
			width: '100%',
			height: '100vh',
			overflowX: 'hidden',
			// background: '#ffffff'
			background: `url(${getRelativePath('images/bg.webp')}) no-repeat center center fixed`,
			backgroundSize: 'cover'
		}
	});

export default Styles;
